import { Link } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const FEATURE_LABELS = {
  cms_pages: "Seitenbuilder",
  theme_studio: "Theme Studio",
  header_footer: "Header & Footer",
  blog: "Blog",
  gallery: "Galerie",
  forms: "Formulare",
  seo: "SEO",
  services: "Leistungen",
  service_categories: "Service-Kategorien",
  addons: "Zusatzleistungen",
  staff: "Mitarbeiter",
  staff_blocks: "Urlaub & Krankheit",
  availability: "Verfügbarkeit",
  bookings: "Buchungen / Kalender",
  ical_sync: "Kalender-Sync (iCal)",
  newsletter: "Newsletter",
  email_templates: "E-Mail-Vorlagen",
  email_smtp: "E-Mail SMTP",
  loyalty: "Treueprogramm",
  analytics: "Auswertung",
  customer_portal: "Kundenbereich",
};

export default function UpgradeRequired({ feature }) {
  const { plan } = useAuth();
  const label = FEATURE_LABELS[feature] || feature;

  return (
    <div className="p-8 lg:p-16 max-w-2xl mv-fade-in" data-testid="upgrade-required">
      <div
        className="mv-card p-10 text-center"
        style={{ background: "var(--mv-surface)" }}
      >
        <div
          className="w-14 h-14 rounded-full mx-auto mb-5 flex items-center justify-center"
          style={{ background: "var(--mv-surface-2)" }}
        >
          <Lock className="w-6 h-6" strokeWidth={1.5} style={{ color: "var(--mv-primary)" }} />
        </div>
        <p className="mv-label mb-2">Upgrade erforderlich</p>
        <h1 className="font-display text-3xl mb-3">{label}</h1>
        <p className="text-sm mb-6" style={{ color: "var(--mv-text-muted)" }}>
          Diese Funktion ist in deinem aktuellen Paket {plan ? <strong>{plan.name}</strong> : null}
          {" "}nicht enthalten. Wechsle in ein höheres Paket, um sie freizuschalten.
        </p>
        <Link
          to="/cms/settings"
          data-testid="upgrade-cta"
          className="mv-btn inline-flex"
        >
          Paket-Optionen ansehen <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
        </Link>
        <p className="text-xs mt-4" style={{ color: "var(--mv-text-muted)" }}>
          Hinweis: Pakete werden vom Plattform-Admin verwaltet — bitte ggf. den StudioMV-Support kontaktieren.
        </p>
      </div>
    </div>
  );
}
